import { Button, Stack, Typography, useTheme } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowInput } from "web_myplann/Shared/Components/FlatRow/FlatRowInput";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import {
	formatThousands,
	parseThousands,
} from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	open: boolean;
	isSaving: boolean;
	onClose: () => void;
	onSubmit: (ownFunds: number) => void;
};

export const SetOwnFundsDrawer: FC<Props> = ({
	open,
	isSaving,
	onClose,
	onSubmit,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const [draft, setDraft] = useState("");

	useEffect(() => {
		if (open) setDraft("");
	}, [open]);

	const amount = parseThousands(draft) ?? 0;

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Goals.Detail.OwnFundsCallout.Drawer.title)}
			closeButton
		>
			<Stack pb={1.6} gap={1.6}>
				<Typography variant="caption" color={theme.palette.grey[500]} px={1.6}>
					{t(Resources.Goals.Detail.OwnFundsCallout.Drawer.description)}
				</Typography>
				<FlatRowInput
					label={t(Resources.Goals.Detail.OwnFundsCallout.Drawer.label)}
					value={formatThousands(draft)}
					onChange={setDraft}
					placeholder={t(
						Resources.Goals.Detail.OwnFundsCallout.Drawer.placeholder,
					)}
					suffix={t(Resources.Goals.Amount.currencySign)}
					inputMode="numeric"
					isLast
				/>
				<Stack px={1.6}>
					<Button
						variant="primary"
						onClick={() => onSubmit(amount)}
						disabled={amount <= 0}
						loading={isSaving}
					>
						{t(Resources.Goals.Detail.OwnFundsCallout.Drawer.submit)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
